import {track} from '@amplitude/analytics-browser';

import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import AMPLITUDE_EVENT_VALUES from '../../consts/amplitude/amplitudeEventValues';
import deviceTypesService from '../device/deviceTypesService';
import amplitude from './amplitude';

const trackPairingSuccess = () => {
    amplitude.trackDeviceAndHolderEvent(AMPLITUDE_EVENT_TYPES.PAIRING, {
        [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: true,
    });
};

const trackDevicePairingError = (deviceType) => {
    const {modelName} = deviceTypesService.getDeviceTypesDataByType(deviceType) || {};

    track(AMPLITUDE_EVENT_TYPES.PAIRING, {
        [AMPLITUDE_EVENT_PROPERTIES.IQOS_PRODUCT_DEVICE_ID]: AMPLITUDE_EVENT_VALUES.UNKNOWN,
        [AMPLITUDE_EVENT_PROPERTIES.IQOS_PRODUCT_MODEL_TYPE]: modelName,
        [AMPLITUDE_EVENT_PROPERTIES.ERROR_MESSAGE]: AMPLITUDE_EVENT_VALUES.PARING_ERROR,
        [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: false,
    });
};

const trackSynchronizationSuccess = (isHolder) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.CONNECTING,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: true,
        },
    });
};

const trackSynchronizationError = (isHolder) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.CONNECTING,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: false,
            [AMPLITUDE_EVENT_PROPERTIES.ERROR_MESSAGE]: AMPLITUDE_EVENT_VALUES.CONNECTING_ERROR,
        },
    });
};

const trackUnpairDeviceStarted = () => {
    amplitude.trackDeviceAndHolderEvent(AMPLITUDE_EVENT_TYPES.UNPAIR_DEVICE_STARTED);
};

const trackUnpairDeviceCompleted = () => {
    amplitude.trackDeviceAndHolderEvent(AMPLITUDE_EVENT_TYPES.UNPAIR_DEVICE_COMPLETED, {
        [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: true,
    });
};

const trackUnpairing = () => {
    // runs synchronously - because we can't have unpair errors, unlike other apps
    trackUnpairDeviceStarted();
    trackUnpairDeviceCompleted();
};

export default {
    trackPairingSuccess,
    trackDevicePairingError,
    trackSynchronizationSuccess,
    trackSynchronizationError,
    trackUnpairing,
};
